import { IconButton, Stack, TextField, Typography } from '@mui/material';
import { useState } from 'react';

import { VXButtons } from '../buttons/vxButtons';

export const RenameEntityName = ({
  name,
  label,
  onSubmit,
  bold = true,
  editMode,
  setEditMode,
  focusOnMount = false,
}: {
  label?: string;
  name: string;
  onSubmit: (name: string) => void;
  bold?: boolean;
  editMode?: boolean;
  setEditMode?: (editMode: boolean) => void;
  focusOnMount?: boolean;
}) => {
  const [internalEditMode, setInternalEditMode] = useState(
    editMode || focusOnMount
  );

  const getEditMode = () => {
    return setEditMode ? editMode : internalEditMode;
  };
  const setEditModeWrapper = (editMode: boolean) => {
    return setEditMode ? setEditMode(editMode) : setInternalEditMode(editMode);
  };

  return (
    <Stack direction='row' alignItems='center' gap='4px'>
      {label && <Typography className='mr-[20px]'>{label}</Typography>}
      {!getEditMode() ? (
        <Stack direction='row' alignItems='center' gap='8px'>
          <Typography className={bold ? 'font-semibold' : ''}>
            {name}
          </Typography>
          <IconButton
            onClick={() => setEditModeWrapper(true)}
            data-testid='rename-entity-name-edit-btn'
          >
            <i
              className={
                'material-symbols-stylus-outline w-[20px] h-[20px] text-(--mui-palette-text-primary)'
              }
            />
          </IconButton>
        </Stack>
      ) : (
        <EditEntityName
          initialName={name}
          onSubmit={onSubmit}
          onClose={() => setEditModeWrapper(false)}
        />
      )}
    </Stack>
  );
};

export const EditEntityName = ({
  initialName,
  onSubmit,
  onClose,
}: {
  initialName: string;
  onSubmit: (name: string) => void;
  onClose: () => void;
}) => {
  const [newName, setNewName] = useState(initialName);

  return (
    <Stack direction='row' alignItems='center' gap='12px'>
      <TextField
        autoFocus={true}
        onFocus={(e) => e.target.select()}
        error={!validateName(newName)}
        slotProps={{ htmlInput: { 'data-testid': 'rename-entity-name-input' } }}
        value={newName}
        onChange={(e) => setNewName(e.target.value)}
      />
      <VXButtons
        onApprove={() => {
          onClose();
          onSubmit(newName);
        }}
        onCancel={() => {
          onClose();
          setNewName(initialName);
        }}
        approveDisabled={!validateName(newName)}
      />
    </Stack>
  );
};

export const validateName = (name = '') => name.trim().length >= 4;
